// Modules
import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import alarm from "assets/audio/alarm.mp3";

// Services
import Triage from "services/data/triage";

// Actions
import { useTriageItems } from "modules/triage/store/actions";

// Components
import TriageItem from "components/models/triage/triage-items";
import FlipMove from "components/widgets/animation/flip-move";

// Constants
import { isMobile } from "constants";

function TriageList(props) {
  const { user } = props;
  // The queue in the right pane is the owner of the subscription: it renders the
  // items, so it is the one that needs them to stay fresh.
  const { items } = useTriageItems({ user, socket: true });

  const { active = [], resolved = [] } = _.groupBy(items, (item) => (_.includes(["Active", "After Hours"], item.status)
        ? "active"
        : "resolved"));

  const resolvedWithDivider =
    resolved.length && active.length
      ? _.concat([], { triageId: "divider", title: "Resolved" }, resolved)
      : resolved;
  const toRender = _.concat(active, resolvedWithDivider);
  const duration = isMobile ? 200 : 500;

  // data-triage-queue marks this subtree as the queue: interactions inside it
  // restart the refresh hold, and it is the key the gate is shared on. Must match
  // TRIAGE_QUEUE_SELECTOR in store/actions.js. The indicator itself is rendered by
  // right-pane, over the header above this container — see hooks/useGatedCallback.
  return (
    <div className="triage-items" data-triage-queue>
      <audio id="triage-audio" src={alarm} autoPlay={false}></audio>
      {/*
        maintainContainerHeight keeps a row leaving the queue from scrolling the
        pane. To animate a row out, FlipMove positions it absolutely so the rows
        below can slide up into its place — which drops this container's height by
        that row's height in a single frame, while the row is still on screen. In a
        fixed-height scroller a shorter content box means a smaller maximum scroll
        offset, so the browser clamps scrollTop to it and the user is scrolled up
        mid-animation. The placeholder holds the space until the animation ends,
        leaving one honest height change after things have settled.
      */}
      <FlipMove duration={duration} maintainContainerHeight>
        {_.map(toRender, (item) => {
          if (item.triageId === "divider") {
            return (
              <div key={item.title} className="divider-title">
                {item.title}
              </div>
            );
          }

          return (
            <div key={item.triageId}>
              <TriageItem item={item} />
            </div>
          );
        })}
      </FlipMove>
    </div>
  );
}

// Internal methods
function mapStateToProps(state) {
  return { user: state.auth.currentUser };
}

// Exports
export default connect(mapStateToProps)(TriageList);
